<template>
  <div class="app bg-gray" id="myReport-myReport">
    <hospital-select @selected="selectHospital()"></hospital-select>
    <voucher-select
      :list="voucherList"
      @selected="selectVoucher"
    ></voucher-select>
    <div class="message-tips">
      <p>
        温馨提示：1.特殊项目（如HIV、梅毒、微生物项目）不能查询；2.查询结果不作为任何医学凭据，请以医院打印报告单为准。
      </p>
    </div>
    <section class="report-container thick" style="margin-top: 1px">
      <div
        @click="onSelectedArea(item)"
        v-for="item in areas"
        :id="'myreport-item-' + item.itemId"
        :key="item.itemId"
        class="report-item"
      >
        <span
          class="report-label"
          :class="{ active: selectedArea.itemId == item.itemId }"
          >{{ item.itemName }}</span
        >
      </div>
    </section>
    <scroll @refresh="refresh" style="top: 5.4rem">
      <no-record
        :condition="reprotList"
        tips="抱歉，没有报告记录"
        id="myreport-norecord"
      ></no-record>
      <section
        class="thick"
        v-for="(report, index) in reprotList"
        :id="'myreport-list-' + index"
        :key="index"
        @click="goReportDetail(report)"
      >
        <div class="panel ellipsis">
          <span>{{ report.examItem ? report.examItem : report.labItem }}</span>
        </div>
        <div class="content arr-row f-minor">
          <span>{{ report.deptName }}/{{ report.doctName }}</span
          ><br />
          <span>完成时间</span>&nbsp;&nbsp;&nbsp;&nbsp;<span>{{
            report.examTime ? report.examTime : report.labTime
          }}</span
          ><br />
        </div>
        <div
          class="bottom arr-row"
          @click.stop="showHelp(report)"
          v-show="printEnable"
          id="myreport-show-qrcode"
        >
          <span class="f-strong">打印报告单</span>
          <div class="right-txm"></div>
        </div>
      </section>
      <popup class="mask" v-model="show" id="myreport-qrcode">
        <div class="show-bar-code">
          <div class="report-detail">
            <div class="report-detail-qrcode">
              <div>
                <p>打印报告二维码</p>
                <!--<div class="bar-code-bg">-->
                <!--<svg id="barcode"></svg>-->
                <!--</div>-->
                <section class="thick" style="margin-top: 40px">
                  <!--<div class="row" style="padding: 1.25rem 0 1.5rem 1.25rem"></div>-->
                  <qrcode
                    :size="171"
                    class="qrcode"
                    :cls="qrCls"
                    :value="qrText"
                  ></qrcode>
                  <!--<o2o-helper :type="0"></o2o-helper>-->
                </section>
              </div>
              <div class="help">
                <div class="introduce-info">
                  <br />
                  <div class="f-minor">
                    第一步，请您前往医院带GWI标识自助设备区域。
                  </div>
                  <br />
                  <div class="f-minor">
                    第二步，请在自助机上的扫描区域扫描该二维码，就可以在自助机上打印报告。
                  </div>
                </div>
                <div class="zhj-img"></div>
              </div>
            </div>
          </div>
        </div>
      </popup>
    </scroll>
  </div>
</template>
<script>
import queryFunc from 'queryFunList.service'
import queryVoucher from 'voucher.service'
import HospitalSelect from 'HospitalSelect'
import VoucherSelect from 'VoucherSelect'
import queryFuncDetail from 'queryFunDetail.service'
import Qrcode from 'v-qrcode'
import NoRecord from 'NoRecord'
import voucherService from 'voucher.service'

export default {
  components: {
    HospitalSelect,
    VoucherSelect,
    Qrcode,
    NoRecord,
  },
  data () {
    const today = new Date()
    const data = {
      areas: [{
        itemName: '检查报告',
        itemId: '1',
        itemNum: '0',
      }, {
        itemName: '检验报告',
        itemId: '2',
        itemNum: '0',
      }],
      show: false,
      selectedArea: {},
      voucherList: [],
      voucher: {},
      reprotList: [],
      qrCls: 'qrcode',
      qrText: '',
      printEnable: false,
      qrcodeEnable: false,
    }
    const date = {}
    date.endDate = today.format('yyyy-MM-dd')
    today.setDate(today.getDate() - 14)
    date.startDate = today.format('yyyy-MM-dd')
    data.date = date
    return data
  },
  created () {
    //判断是否存在tokenId,且当前界面code失效
    var query = this.$router.currentRoute.query
    var code = query.code
    if (code) {
      var getTokenParams = { code: code }
      voucherService.getToken(getTokenParams).then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          //查询该用户未使用过该公众号
          this.loadVouchers()
          return
        }
        //缓存最新code给后台
        localStorage.setItem('deviceId', code);
        sessionStorage.setItem('deviceId', code);
        //返回新token保存本地使用
        localStorage.tokenId = res.data.tokenId;
        localStorage.setItem('tokenId', res.data.tokenId);
        sessionStorage.setItem('tokenId', res.data.tokenId);
        window.http.headers.common['tokenId'] = localStorage.tokenId || ''
        window.http.headers.common['deviceId'] = localStorage.deviceId || ''
        this.loadVouchers()
      })
    } else {
      this.loadVouchers()
    }
  },
  methods: {
    refresh () {
      if (!this.voucher.cardNo) {
        this.loadVouchers()
        return
      }
      this.selectedArea = this.areas[0]

      // 处理初始进入微信的未选医院情况
      if (typeof (window.http.headers.common.hospitalId) === 'undefined') {
        this.$utils.alert('请选择医院')
        return
      }
      // 默认加载检查检验报告获取数量
      this.loadMyExamList()
     // this.loadMyLabList()
    },
    loadVouchers () {
      // 获取用户就诊凭证
      queryVoucher.getVoucherList().then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
          return;
        }

        const data = res.data;
        if (data.length === 0) {
          this.$utils.alert('请先绑定诊疗卡');
          return;
        }
        this.voucherList = data;
        // 首次进入，默认第一张诊疗卡信息
        this.voucher = JSON.parse(JSON.stringify(this.voucherList[0]));

        // 保存默认卡信息
        this.$store.commit('updateParam', {
          namespace: 'mypay',
          voucher: this.voucher,
        });
        this.refresh();
      });
    },
    selectHospital () {
      this.reprotList = this.constant.ARRAY_CLEAN
      this.refresh()
    },
    selectVoucher (v) {
      this.voucher = v
      this.reprotList = this.constant.ARRAY_CLEAN

      // 保存默认卡信息
      this.$store.commit('updateParam', {
        namespace: 'mypay',
        voucher: v,
      })
      // 加载默认卡的待缴费列表
      this.refresh()
    },
    onSelectedArea (item) {
      if (this.selectedArea.itemId === item.itemId) {
        return
      }
      // 判断是否绑定诊疗卡
      if (this.voucherList.length === 0) {
        return
      }
      this.reprotList = this.constant.ARRAY_CLEAN
      this.selectedArea = item
      if (this.selectedArea.itemId === '1') {
        this.loadMyExamList()
        return
      }
      this.loadMyLabList()
    },
    loadMyExamList () {
      this.printEnable = false
      const params = {
        cardType: this.voucher.cardType,
        cardNo: this.voucher.cardNo,
        startDate: this.date.startDate,
        endDate: this.date.endDate,
      }
      queryFunc.getExamList(params).then((res) => {
        let result = []
        if (res.resultCode === this.constant.RESULT_SUCCESS) {
          result = res.data
          this.areas[0].itemNum = result.length
        } else {
          //this.$utils.alert(res.resultMsg)
          this.reprotList = []
          this.areas[0].itemNum = '0'
        }
        this.reprotList = result
      }, () => {
        this.reprotList = []
        this.areas[0].itemNum = '0'
      })
    },
    loadMyExamDetail (report) {
      const queryParam = {
        cardType: this.voucher.cardType,
        cardNo: this.voucher.cardNo,
        startDate: this.date.startDate,
        endDate: this.date.endDate,
        examId: report.examId,
      }
      queryFuncDetail.getExamDetail(queryParam).then((res) => {
        if (res.resultCode === this.constant.RESULT_SUCCESS) {
          // 二维码
          this.qrText = res.data.qrCode
        } else {
          this.$utils.alert(res.resultMsg)
        }
      })
    },
    loadMyLabList () {
      let selectedHospital = localStorage.selectedHospital;
      if (selectedHospital) {
        if (JSON.parse(selectedHospital).hospitalId === this.constant.HOSPITAL_ID.FYBJ) {
          this.printEnable = true;
        } else {
          this.printEnable = false
        }
      }
      const params = {
        cardType: this.voucher.cardType,
        cardNo: this.voucher.cardNo,
        startDate: this.date.startDate,
        endDate: this.date.endDate,
      }
      queryFunc.getLabList(params).then((res) => {
        let result = []
        if (res.resultCode === this.constant.RESULT_SUCCESS) {
          result = res.data
          this.areas[1].itemNum = result.length
        } else {
          //this.$utils.alert(res.resultMsg)
          this.reprotList = []
          this.areas[1].itemNum = '0'
        }
        this.reprotList = result
      }, () => {
        this.reprotList = []
        this.areas[1].itemNum = '0'
      })
    },
    loadMyLabDetail (report) {
      const queryParam = {
        cardType: this.voucher.cardType,
        cardNo: this.voucher.cardNo,
        startDate: this.date.startDate,
        endDate: this.date.endDate,
        labId: report.labId,
      }
      queryFuncDetail.getLabDetail(queryParam).then((res) => {
        if (res.resultCode === this.constant.RESULT_SUCCESS) {
          // 二维码
          this.qrText = res.data.qrCode
        } else {
          this.$utils.alert(res.resultMsg)
        }
      })
    },
    goReportDetail (report) {
      if (this.selectedArea.itemId === '1') {
        //                    this.$utils.alert('暂无检查详情')
        //                    return
        // 跳转检查报告详情，后续备用，误删！
        this.$store.commit('updateParam', {
          namespace: 'myExam',
          report: report,
          queryParam: {
            cardType: this.voucher.cardType,
            cardNo: this.voucher.cardNo,
            startDate: this.date.startDate,
            endDate: this.date.endDate,
            examId: report.examId,
            examTime: report.examTime,
            examItem: report.examItem
          }
        })
        this.$router.push('examdetail')
        return;
      }

      this.$store.commit('updateParam', {
        report,
        namespace: 'myLab',
        queryParam: {
          cardType: this.voucher.cardType,
          cardNo: this.voucher.cardNo,
          startDate: this.date.startDate,
          endDate: this.date.endDate,
          labId: report.labId,
          labTime: report.labTime,
          labItem: report.labItem,
        },
      })
      this.$router.push('labdetail')
    },
    showHelp (report) {
      // 没有检查详情处理
      if (this.selectedArea.itemId === '1') {
        this.$utils.alert('没有检查详情')
        return
      }
      this.show = !this.show
      if (this.show) {
        if (this.selectedArea.itemId === '1') {
          this.loadMyExamDetail(report)
          return
        }
        this.loadMyLabDetail(report)
      }
    },
  },
}
</script>

<style lang="scss">
@import "../../../static/sass/_variable.scss";
.report-container {
  height: 1.2rem;
  background: #fff;
  width: 100%;
  display: flex;
  display: -webkit-flex;
  .report-item {
    text-align: center;
    flex: 1;
    line-height: 1.2rem;
    width: 50%;
  }
  .report-label {
    display: inline-block;
    height: 100%;
    padding: 0 20px;
    &.active {
      color: $main-style-color;
      border-bottom: 2px solid $main-style-color;
    }
  }
}

.right-txm {
  width: 1rem;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 30px;
  background: url("../../../static/img/qr-code.png") no-repeat center;
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// MyReport.vue?83af130a